import { PageDefaultSegmentWithHeader } from "@sis/react-library"
import { TrackFormWrapper } from "../trackForm/TrackFormWrapper"
import { getSearchCategory, getSearchProvider } from "../trackPage/trackPageHelper"
import { Track } from "../../../interfaces/dtos/track";
import { useSearchParams } from "react-router-dom";
import { RppTitle } from "../../shared/RppTitle";
import { segmentHeaderDefault } from "../../../utils/commonUtils";
import { useTheme } from "@mui/material";

export const TrackNewPage = () => {

  const theme = useTheme();
  const [searchParams] = useSearchParams();

  const defaultNewTrack: Track = {
    categoryCode: getSearchCategory(searchParams) ?? undefined,
    provider: getSearchProvider(searchParams) ?? undefined,
    isEPDisplay: false, isEPDistribute: false, isBPDisplay: false, isBPDistribute: false, isTrackActive: false
  }

  return (
    <PageDefaultSegmentWithHeader
      headingText="New Track Code"
      headingBackground={segmentHeaderDefault(theme)}
      headingColor={theme.palette.common.white}
      standardWidth
    >
      <RppTitle title="New Track Code" />
      <TrackFormWrapper track={defaultNewTrack} />
    </PageDefaultSegmentWithHeader>
  )
}
